module.exports = __webpack_public_path__ + "static/media/ad.5c3082e6.png";